<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
        <v-layout>
            <v-flex>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-alert
      :value="true"
      type="info"
      v-if="!availableSurveys && !pageLoading"
    >
        En este momento no hay encuestas activas
    </v-alert>
    <div v-else-if="!pageLoading">
      <v-toolbar flat color="white">
        <v-toolbar-title>Encuestas</v-toolbar-title>
      </v-toolbar>
      <v-container fluid class="pa-0 pt-2">
        <v-layout row wrap class="table-responsive" >
          <table class="table table-striped table-hover table-bordered elevation-3" >
            <thead>
              <tr>
                <th>ENCUESTA</th>
                <th><i class="material-icons">family_restroom</i><br>{{ user.name }}<br><small style="font-weight: 400">FAMILIA</small></th>
                <th v-for="student in students" :key="student.student_id">
                  <i class="material-icons">child_care</i><br> {{ student.first_name }}<br><small style="font-weight: 400">{{ schools[`${student.school_id}`] }}</small>
                </th>
              </tr>
            </thead>
            <tbody>
                <tr
                  v-for="(survey, i) in surveys"
                  :key="`ds-${i}`"
                >
                <th>
                  <div style="min-width: 300px">{{ survey.name }}<br><small style="font-weight: 400">{{ survey.description }}</small></div>
                </th>
                <td style="text-align: center; width: 160px;">
                  <div v-if="survey.type == 'FML'">
                    <v-btn
                      slot="activator"
                      @click="handleSurvey(survey.id)"
                      :color="getColor(survey.id)"
                    >
                      {{ getText(survey.id) }}
                    </v-btn>
                  </div>
                  <div v-else class="text-center">
                    <i class="material-icons grey--text text--lighten-1">highlight_off</i>
                  </div>
                </td>
                <td v-for="student in students" :key="student.student_id+survey.id" style="text-align: center; width: 160px;">
                  <div v-if="survey.type == 'STU'" class="text-center">
                    <v-btn v-if="getQuestions(survey.id, student.grade_level)"
                      slot="activator"
                      @click="handleSurvey(survey.id, student.student_id)"
                      :color="getColor(survey.id, student.student_id)"
                    >                      
                      {{ getText(survey.id, student.student_id) }}
                    </v-btn>
                    <i v-else class="material-icons grey--text text--lighten-1">highlight_off</i>
                  </div>
                  <div v-else class="text-center">
                    <i class="material-icons grey--text text--lighten-1">highlight_off</i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-if="survey_id"
      v-model="dialogSurvey"
      max-width="700px"
    >
      <survey-run
        :surveyId="survey_id"
        :studentId="student_id"
        v-on:finished="finished"
      />
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import surveyRun from './run/run.vue'
  export default {
    name: 'surveys-employee-view',
    components: {
      'survey-run': surveyRun,
    },
    data() {
      return {
        surveys: [],
        students: [],
        pageLoading: true,
        dialogSurvey: false,
        survey_id: null,
        student_id: 0,
        vista_action: '',
        vista_record_id: '',
        rowid_tercero: '',
        schools: [],
      }
    },
    computed: {
      availableSurveys() {
        return this.surveys.length > 0
      },
      ...mapGetters({
        user: 'authUser'
      })
    },
    created () {
      this.init();
      this.schools[10000] = 'Early years'
      this.schools[11000] = 'Elementary School'
      this.schools[12000] = 'Middle School'
      this.schools[13000] = 'High School'
      this.schools[14000] = 'Admissions'
    },
    methods: {
      init() {
        axios.get('/api/surveys/available')
          .then(resp => {
            if (resp.status === 200) {
              this.surveys = resp.data.surveys
              this.students = resp.data.students
              this.pageLoading = false
            }
          })
          .then(err => {
            this.pageLoading = false
          })
      },
      getColor(survey_id, student_id = 0) {
        let color = 'primary'
        let completed = []
        const responses = this.surveys.find(survey => survey.id === survey_id).responses

        if (responses.length > 0) {
          if (student_id != 0) {
            completed = responses.filter(response => response.student_id == student_id && response.status === 1)
          } else {
            completed = responses.filter(response => response.status === 1)
          }

          if (completed.length > 0) {
            color = 'success'
          }
        }

        return color
      },
      getText(survey_id, student_id = 0) {
        let text = 'Comenzar'
        let completed = []
        const responses = this.surveys.find(survey => survey.id === survey_id).responses

        if (responses.length > 0) {
          if (student_id != 0) {
            completed = responses.filter(response => response.student_id == student_id && response.status === 1)
          } else {
            completed = responses.filter(response => response.status === 1)
          }

          if (completed.length > 0) {
            text = 'Finalizada'
          }
        }
        return text
      },
      getQuestions(survey_id, grade_level) {
        let show = false
        let questions_grade = []
        const questions = this.surveys.find(survey => survey.id === survey_id).questions

        if (questions.length > 0) {
          questions_grade = questions.filter(question => question.grades.includes('ALL') || question.grades.includes(grade_level))
          if (questions_grade.length > 0) {
            return true
          }
        }
        return false
      },
      async handleSurvey(survey_id, student_id = 0) {
        if (this.getText(survey_id, student_id) == 'Finalizada') {
          return
        }
        
        this.student_id = student_id
        this.survey_id = survey_id
        this.dialogSurvey = true
      },
      finished() {
        this.dialogSurvey = false
        this.survey_id = null
        this.student_id = 0
        this.init()
      }
    },
  }
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
}
.table {
  margin-bottom: 1rem;
  background-color: #FFFFFF;
  max-width: 100%;
  width: 100%;
}
.table td, .table th {
  padding: .75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: middle;
  border-bottom: 2px solid #dee2e6;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0,0,0,.03);
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #dee2e6;
}
.table-hover tbody tr:hover {
  background-color: rgba(5, 112, 199, 0.055);
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/survey_list.vue